import { render } from "./SettingComponent.vue?vue&type=template&id=242f2902"
import script from "./SettingComponent.vue?vue&type=script&lang=js"
export * from "./SettingComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__